// Libs
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Tooltip from '@mui/material/Tooltip';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { useSnackbar } from 'notistack';

// Components
import LineChart from './ChartTotal.jsx';

// Services
import { DELETE } from "../../../services/Bridge.js"

// Assets
import noCar from "../../../assets/noCar.jpg";

// Style
import style from "./style.module.css"

const oneWeekAgo = new Date();
oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);

const dph = process.env.REACT_APP_DPH;
const imageTemplateExt = process.env.REACT_APP_IMAGE_TEMPLATE_EXT;
const apiUrl = process.env.REACT_APP_API_URL;

const Item = ({ item, webText, webLanguage, authenticated }) => {

  const navigate = useNavigate();

  const { enqueueSnackbar } = useSnackbar();

  const [openDeleteVerify, setOpenDeleteVerify] = useState(false);
  const [removing, setRemoving] = useState(false);
  const [active, setActive] = useState(1);
  const [openArchiveVerify, setOpenArchiveVerify] = useState(false);
  // eslint-disable-next-line
  const [archiving, setArvhiving] = useState(false);

  const Feature = ({ feature }) => (
    <div className="featuresDiv">
      <Tooltip
        title={webLanguage === "sk" ? feature.skTranslation : feature.description}
        placement="top"
        color="main"
        disableInteractive
        arrow
      >
        <p>{feature.short}</p>
      </Tooltip>
    </div>
  );

  const handleOpenDeleteVerify = async () => {

    setRemoving(true);

    try {
        await DELETE({
          path: "advertisement",
          params: { id: item.id }
        });

        enqueueSnackbar(webText.saved, {
          variant: "success",
          autoHideDuration: 3000,
          onEntered: () => setOpenDeleteVerify(false),
          onClose: () => setRemoving(false)
        });

        window.location.reload();

    } catch (error) {
        /* enqueueSnackbar(error, {
          variant: "error",
          autoHideDuration: 5000,
          onEntered: () => setOpenDeleteVerify(false),
          onClose: () => setRemoving(false)
        }); */

        setOpenDeleteVerify(false);
        setRemoving(false);
    };
  };

  const handleArchiveAdversiment = () => {
    /* setArvhiving(true);
    Axios
      .put(`${process.env.REACT_APP_API_URL}/advertisement-archive`, {
        params: { id: item.id },
        paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets', encode: false })
      })
      .then(response => {
        if (response.data === "Authorization Token is invalid or expired.") {
          enqueueSnackbar(webText.authTokenisInvalidOrExpired, {
            variant: "error",
            autoHideDuration: 5000
          });
        } else {
          enqueueSnackbar(webText.saved, {
            variant: "success",
            autoHideDuration: 3000,
            onEntered: () => setOpenArchiveVerify(false),
            onClose: () => setArvhiving(false)
          });
        };
      })
      .catch(() => {
        enqueueSnackbar(webText.noConnection, {
          variant: "error",
          autoHideDuration: 5000,
        });
      }); */
  };

  /* const handleUnArchiveAdversiment = () => {

  }; */

  const getFormatedDate = ( time ) => {
    const currentDate = new Date(time);
    let year = currentDate.getFullYear();
    let month = currentDate.getMonth() + 1; // Months are zero-based, so add 1
    let day = currentDate.getDate();
    let hours = currentDate.getHours(); // 24-hour format
    let minutes = currentDate.getMinutes();
    let seconds = currentDate.getSeconds();

    // Adding leading zeros if day, month, hours, or minutes are single digits
    day = day < 10 ? '0' + day : day;
    month = month < 10 ? '0' + month : month;
    hours = hours < 10 ? '0' + hours : hours;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    seconds = seconds < 10 ? '0' + seconds : seconds;

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  };

  return authenticated ? (
    <div className={style.adminItem}>

      <h1 className={style.title} onClick={() => navigate(`/item/${item.id}`)}>{item.title}</h1>

      <div className={style.thumbnailBox}>
        {item.images.length > 0 ?
          <img
            src={`${apiUrl}/data/${item.id}/templates/${item.images[0].fileName}.${imageTemplateExt}?width=150`}
            alt="Thumbnail"
            onClick={() => navigate(`/item/${item.id}`)}
            className={style.thumbnail}
          />
          :
          <img src={noCar} alt="Thumbnail" onClick={() => navigate(`/item/${item.id}`)} className={style.thumbnail}/>
        }
        <div className={style.statusBox}>
          {item.dateAdded >= oneWeekAgo.getTime() ?
            <Tooltip
              title={webText.chipsNew}
              placement="top"
              color="main"
              disableInteractive
              arrow
              onClick={(event) => event.stopPropagation()}
            >
              <p className={style.newItem}>Nové</p>
            </Tooltip> : void[0]
          }
          {item.stateChips.includes("prepairing") ?
            <Tooltip
              title={webText.chipsPrepairing}
              placement="top"
              disableInteractive
              arrow
              onClick={(event) => event.stopPropagation()}
            >
              <p className={style.prepairingItem}>Pripravujeme</p>
            </Tooltip> : void[0]
          }
          {item.stateChips.includes("reserved") ?
            <Tooltip
              title={webText.chipsReserverd}
              placement="top"
              disableInteractive
              arrow
              onClick={(event) => event.stopPropagation()}
            >
              <p className={style.reservedItem}>Rezervované</p>
            </Tooltip> : void[0]
          }
        </div>
      </div>

      <fieldset className={style.infoBox}>
        <legend>Informácie o inzeráte</legend>
        <p className={style.price}>Cena: {item.price} €</p>
        {item.minusDph &&
          <p className={style.minusDphText}>- možný odpočet DPH</p>
        }
        <p className={style.adder}>Pridal: {item.adder || "Neznáme"}</p>
        <p className={style.dateAdded}>Dátum Pridania: {getFormatedDate(item.dateAdded)}</p>
        <p className={style.dateEdited}>Dátum poslednej úpravy: {getFormatedDate(item.lastEdited)}</p>
      </fieldset>

      <p className={style.viewsCounter}>Počet kliknutí: {active === 1 ? item.views9999.totalClicked || "0" : active === 2 ? item.views1.totalClicked || "0" : active === 3 ? item.views7.totalClicked || "0" : item.views30.totalClicked || "0"}</p>
      <button className={`${style.btnTotal} ${active === 1 ? style.active : ""}`} onClick={() => setActive(1)}>Celkovo</button>
      <button className={`${style.btnDay} ${active === 2 ? style.active : ""}`} onClick={() => setActive(2)}>Deň</button>
      <button className={`${style.btnWeek} ${active === 3 ? style.active : ""}`} onClick={() => setActive(3)}>Týždeň</button>
      <button className={`${style.btnMonth} ${active === 4 ? style.active : ""}`} onClick={() => setActive(4)}>Mesiac</button>

      <div className={style.chart}>
        <LineChart
          item={item}
          webText={webText}
          active={active}
        />
      </div>

      <Tooltip
        title={webText.editButton}
        placement="top"
        disableInteractive
        arrow
      >
        <svg viewBox="0 0 512 512" className={style.editButton} onClick={() => navigate(`/edit/${item.id}`)}>
          <path d="M362.7 19.3L314.3 67.7 444.3 197.7l48.4-48.4c25-25 25-65.5 0-90.5L453.3 19.3c-25-25-65.5-25-90.5 0zm-71 71L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4L1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L421.7 220.3 291.7 90.3z"/>
        </svg>
      </Tooltip>

      {/*
      <Tooltip
        title={webText.markAsSelled}
        placement="top"
        disableInteractive
        arrow
      >
        <svg viewBox="0 0 512 512" className={style.selledButton} onClick={() => setOpenArchiveVerify(true)}>
            <path d="M32 32l448 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96L0 64C0 46.3 14.3 32 32 32zm0 128l448 0 0 256c0 35.3-28.7 64-64 64L96 480c-35.3 0-64-28.7-64-64l0-256zm128 80c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16z"/>
        </svg>
      </Tooltip>
      */}

      <Tooltip
        title={webText.removeButton}
        placement="top"
        disableInteractive
        arrow
      >
        <svg viewBox="0 0 448 512" className={style.removeButton} onClick={() => setOpenDeleteVerify(true)}>
            <path d="M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z"/>
        </svg>
      </Tooltip>

      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={openDeleteVerify}
      >
        {!removing ?
          <div className={style.removeButtonVerifyContent}>
            <p className={style.removeButtonVerifyContentTitle}>Vymazať inzerát ?</p>
            <button className={style.cancel} onClick={() => setOpenDeleteVerify(false)}>Zrušiť</button>
            <button className={style.accept} onClick={handleOpenDeleteVerify}>Vymazať inzerát</button>
          </div>
          :
          <div className={style.removeButtonVerifyContentRemoving}>
            <p>Vymazávam . .</p>
            <CircularProgress color="inherit" />
          </div>
        }
      </Backdrop>

      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={openArchiveVerify}
      >
        {!archiving ?
          <div className={style.RemoveButtonVerifyContent}>
            <p>{webText.saveValidPrompt}</p>
            <div>
              <button className={style.yes} onClick={handleArchiveAdversiment}>{webText.yes}</button>
              <button className={style.no} onClick={() => {setOpenArchiveVerify(false)}}>{webText.no}</button>
            </div>
          </div>
          :
          <div className={style.RemoveButtonVerifyContentRemoving}>
            <p>{webText.archiving}</p>
            <CircularProgress color="inherit" />
          </div>
        }
      </Backdrop>

    </div>
  ) : (
    <div className={style.item}>

      <div className={style.thumbnailBox}>
        {item.images.length > 0 ?
          <img
            src={`${apiUrl}/data/${item.id}/templates/${item.images[0].fileName}.${imageTemplateExt}?width=150`}
            alt="Thumbnail"
            onClick={() => navigate(`/item/${item.id}`)}
            className={style.thumbnail}
          />
          :
          <img src={noCar} alt="Thumbnail" onClick={() => navigate(`/item/${item.id}`)} className={style.thumbnail}/>
        }
        <div className={style.statusBox}>
          {item.dateAdded >= oneWeekAgo.getTime() ?
            <Tooltip
              title={webText.chipsNew}
              placement="top"
              color="main"
              disableInteractive
              arrow
              onClick={(event) => event.stopPropagation()}
            >
              <p className={style.newItem}>Nové</p>
            </Tooltip> : void[0]
          }
          {item.stateChips.includes("prepairing") ?
            <Tooltip
              title={webText.chipsPrepairing}
              placement="top"
              disableInteractive
              arrow
              onClick={(event) => event.stopPropagation()}
            >
              <p className={style.prepairingItem}>Pripravujeme</p>
            </Tooltip> : void[0]
          }
          {item.stateChips.includes("reserved") ?
            <Tooltip
              title={webText.chipsReserverd}
              placement="top"
              disableInteractive
              arrow
              onClick={(event) => event.stopPropagation()}
            >
              <p className={style.reservedItem}>Rezervované</p>
            </Tooltip> : void[0]
          }
        </div>
      </div>

      <h1 className={style.title} onClick={() => navigate(`/item/${item.id}`)}>{item.title}</h1>

      {!item.features.length ?
          <div className={style.text}>
              {item.description.split('\n').map((line, index) => (
                  <span key={index}>{line}<br /></span>
              ))}
          </div>
          :
          <>
              {item.features.map((feature, index) => (
                  <Feature
                    key={index}
                    feature={feature}
                  />
              ))}
          </>
      }

      <p className={style.price}>{item.price} €</p>

      {item.minusDph ?
        <p className={style.minusDphPrice}>{Math.round(item.price / dph)} € bez DPH</p>
        :
        <p className={`${style.minusDphPrice} empty`}>.</p>
      }

      {item.minusDph ?
        <p className={style.minusDphText}>- možný odpočet DPH</p>
        :
        <p className={`${style.minusDphText} empty`}>.</p>
      }

    </div>
  );
};

export default Item;